import React, { useEffect, useState } from "react";
import { confirmable } from "react-confirm";
import { Switch, Row, message, TreeSelect, Radio, Input, Col } from "antd";
import Modal from "antd/lib/modal/Modal";
import parse from "html-react-parser";
import "./MessageDetailModal.css";

const { SHOW_PARENT } = TreeSelect;
function MessageDetailModal(props) {
  const { show, proceed, title, subject, content, send_date, attachment, attachmentUrl } =
    props;

  const onEditorStateChange = (e) => {
    // if (e != null) {
    //   let selStr = draftToHtml(convertToRaw(e.getCurrentContent()));
    //   setContent(selStr);
    //   setEditorState(e);
    // }
  };
  return (
    <Modal
      open={show}
      destroyOnClose={true}
      onCancel={() => {
        proceed(null);
      }}
      className="message-detail-dlg"
      closable={true}
      maskClosable={false}
      title={title}
      okText="Ok"
      onOk={() => {
        proceed(null);
      }}
    >
      <Row style={{ marginTop: 20 }} gutter={32}>
        <Col style={{ fontWeight: 600 }}>Subject:</Col>
        <Col>{subject}</Col>
      </Row>
      <Row style={{ marginTop: 10 }} gutter={32}>
        <Col style={{ fontWeight: 600 }}>Send Date:</Col>
        <Col>{send_date}</Col>
      </Row>
      <div style={{ marginTop: 10 }}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Content</div>
        <div className="editor-rect" style={{ overflowY: 'auto', overflowX: 'hidden' }}>
          {content ? (
            <div style={{ maxWidth: '100%', wordWrap: 'break-word' }}>
              {parse(content)}
            </div>
          ) : (
            <p>No content available</p>
          )}
        </div>
      </div>
      {attachment && attachment !== "" && (
        <div style={{ marginTop: 10 }}>
          <div style={{ fontWeight: 600, marginBottom: 5 }}>Attachment:</div>
          <a
            download={attachment}
            href={attachmentUrl || `#`}
            target={attachmentUrl ? "_blank" : undefined}
            rel={attachmentUrl ? "noopener noreferrer" : undefined}
          >
            {attachment}
          </a>
        </div>
      )}
    </Modal>
  );
}

export default confirmable(MessageDetailModal);
